import React, { useEffect, useState } from "react";
import NavbarSuperAdmin from "../../../components/navbar/NavbarSuperAdmin";
import { Table } from "react-bootstrap";
import { TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
//import { GoToBack } from "../../../components/ui/GoToBack header/GoToBack";
import { GoToBack }  from "../../../components/ui/GoToBack header/GoToBackR5";
import axios from "axios";
import { API_BASE_PATH } from "../../../constants/workerConstants";
import { toast } from "react-toastify";
import { FadeLoader } from "react-spinners";
import { connect } from "react-redux";
import ReactPaginate from "react-paginate";
import {useParams, useHistory, useLocation } from "react-router-dom";
import { DateTime } from "luxon";

function MyTrips(props) {
  const getParams = useParams();
  const history = useHistory();
  let [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(1);

  const [activePage, setActivePage] = useState(Object.keys(getParams).length > 0 ? getParams['id'] : 1);
  console.log('activePage', activePage, getParams)
  async function getdata(page = 1) {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${API_BASE_PATH}/bouncie/getTripHistory?page=${page}&limit=10`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: props.authToken,
          },
        }
      );
    // console.log(response);
      
    const formatTimezone = (tz) => tz.replace(/([+-]\d{2})(\d{2})/, "$1:$2");

const formatData = response.data.result.tripHistory.map((item) => ({
  ...item,
  startTime: item.start
    ? DateTime.fromISO(item.start.timestamp, { zone: "utc" }) // parse as UTC
        .setZone(`UTC${formatTimezone(item.start.timezone)}`) // apply API timezone
        .toFormat("yyyy-MM-dd HH:mm:ss") // desired format
    : null,
  endTime: item.end
    ? DateTime.fromISO(item.end.timestamp, { zone: "utc" })
        .setZone(`UTC${formatTimezone(item.end.timezone)}`)
        .toFormat("yyyy-MM-dd HH:mm:ss")
    : null,
}));
      // const formatData = response.data.result.tripHistory.map((item) => ({
      //   ...item,
      //  start: item.start ? formatDate(item.start.timestamp) : null,
      //  end: item.end ? formatDate(item.end.timestamp) : null,
      // }));
    //  console.log(formatData);
      
      setData(formatData);
      setTotalPages(response.data.result.totalPage || 1);
      setActivePage(page);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getdata(activePage);
  }, []);


  function formatDate(d) {
    const date = new Date(d);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
  }

  function nextPage(pageNum) {
    getdata(pageNum);
    console.log('history.push', `/mytrips/${ pageNum }`)
    history.push(`/mytrips/${ pageNum }`)
  }

  const handleview = (transactionId,imei,vin,start,end) => {
    history.push("/Viewsingletripdata", { transactionId, imei, vin, start, end   });
  };

  return (
    <>
      <NavbarSuperAdmin />
      <div className="pl">
        <GoToBack>My Trip</GoToBack>
        <div style={{ maxWidth: "800px", width: "100%", margin: "auto" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center">
                  <b style={{ fontSize: "14px" }}>Transaction Id</b>
                </TableCell>
                <TableCell align="center">
                  <b style={{ fontSize: "14px" }}>Start Date/Time</b>
                </TableCell>
                <TableCell align="center">
                  <b style={{ fontSize: "14px" }}>End Date/Time</b>
                </TableCell>
                <TableCell align="center">
                  <b style={{ fontSize: "14px" }}>Status</b>
                </TableCell>
                <TableCell align="center">
                  <b style={{ fontSize: "14px" }}> </b>
                </TableCell>
              </TableRow>
            </TableHead>
            {data.length === 0 ? (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={5}>
                    <div
                      className="text-center mt-5"
                      style={{
                        backgroundColor: isLoading
                          ? "rgb(29 117 189 / 85%)"
                          : "rgb(29, 117, 189)",
                        color: "rgb(255, 255, 255)",
                        padding: "0.5rem 0",
                        borderRadius: "5px",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        height: isLoading ? "40px" : "auto",
                      }}
                    >
                      {!isLoading && "No Data Available"}

                      <FadeLoader
                        height={10}
                        loading={isLoading}
                        margin={-7}
                        speedMultiplier={3}
                        width={4}
                        color="#fff"
                      />
                    </div>
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <TableBody>
                {data.map((row, i) => (
                  <TableRow key={i}>
                    <TableCell
                      align="center"
                      style={{
                        fontSize: "13.5px",
                        padding: "16px 2px",
                      }}
                    >
                      <b style={{ color: "black" }}>{row.transactionId}</b>
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontSize: "13.5px", padding: "16px 2px" }}
                    >
                      <b>{row.startTime ? row.startTime : "-"}</b>
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontSize: "13.5px", padding: "16px 2px" }}
                    >
                      <b>{row.endTime ? row.endTime : "-"}</b>
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontSize: "13.5px", padding: "16px 2px",color: row.endTime ? "green" : "orange", }}
                    >
                      <b>{row.end ? "Completed" : "In Progress"}</b>
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontSize: "13.5px", padding: "16px 2px" }}
                    >
                      {row.end ? 
                      <button className="btn"     onClick={()=>{handleview(row.transactionId,row.imei,row.vin,row.start,row.end)}}  style={{
                        marginRight: "10px",
                        alignItems: "right",
                        backgroundColor: "rgb(29, 117, 189)",
                        color: "rgb(255, 255,255)",
                      }}>View</button>: <p></p>
                    }
                      
                    </TableCell>
                    
                  </TableRow>
                ))}
              </TableBody>
            )}
          </Table>

          {/* Pagination outside Table but inside container */}
          <div id={"react-paginate"} className="bottom-navi-custom" style={{ marginTop: "40px", paddingTop:"40px" ,marginBottom:"0px"}}>
            {totalPages > 1 ? (
              <ReactPaginate
                previousLabel={"<"}
                nextLabel={">"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={totalPages}
                marginPagesDisplayed={2}
                pageClassName={"navi-li"}
                pageRangeDisplayed={2}
                // onPageChange={(page) => {
                //   // setActivePage(parseInt(page.selected) + 1);
                //   // // console.log('page.selected',parseInt(page.selected) + 1)
                //   // // history.push(`/mytrips/${page.selected + 1}`);
                //   // console.log('history.push', `/mytrips/${page.selected + 1}`)
                //   nextPage(page.selected + 1);
                  
                // }}
                onClick={(page) => {
                  if (page.nextSelectedPage){
                    history.push(`/mytrips/${page.nextSelectedPage + 1}`);
                    nextPage(page.nextSelectedPage + 1);
                  }
                  
                  // console.log('page+++', page)
                }}
                initialPage={activePage - 1}
                containerClassName={"pagination"}
                activeClassName={"active"}
              />
            ):"no data found"}
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    authToken: state.persist.authToken,
  };
};

export default connect(mapStateToProps)(MyTrips);
